import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// Tab filters, page and the open item live in the URL so links, refresh and Back keep them.
export function useQueryParams() {
  const [params, setParams] = useSearchParams();
  const update = useCallback((changes, { replace = false } = {}) => {
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(changes).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') next.delete(key);
        else next.set(key, String(value));
      });
      return next;
    }, { replace });
  }, [setParams]);
  return [params, update];
}
